module.exports = __webpack_public_path__ + "static/img/icon_Android@2x.69f41e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software/icon_Android@2x.png
// module id = 60
// module chunks = 0